import { render, staticRenderFns } from "./TalkTrendPersonaPage.vue?vue&type=template&id=686f0deb&scoped=true"
import script from "./TalkTrendPersonaPage.vue?vue&type=script&lang=js"
export * from "./TalkTrendPersonaPage.vue?vue&type=script&lang=js"
import style0 from "./TalkTrendPersonaPage.vue?vue&type=style&index=0&id=686f0deb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f0deb",
  null
  
)

export default component.exports